// extracted by mini-css-extract-plugin
export default {"container":"LoginForm_container__Vv3Zv","button":"LoginForm_button__rDQS7","message":"LoginForm_message__E0AJV"};